// extracted by mini-css-extract-plugin
export default {"main":"FormLinkedItemSimpleSelect_main__mBZIn","label":"FormLinkedItemSimpleSelect_label__0g+72"};